import { Descriptions } from "@/components/v2";
import { Card } from "@rumbledirect/ui";
import { type DescriptionsProps, Button, Space, Popconfirm } from "antd";
import { Link } from "react-router-dom";
import type { ImageCaptureAccount } from "@rumble-it/common-lib/types/models/ImageCapture.interface";
import type { UseMutationResult } from "@tanstack/react-query";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

interface ImageCaptureAccountDetailCardProps {
  account: ImageCaptureAccount | null | undefined;
  isLoading: boolean;
  deleteMutation?: UseMutationResult<null, Error, void, unknown>;
}

export const ImageCaptureAccountDetailCard = ({
  account,
  isLoading,
  deleteMutation,
}: ImageCaptureAccountDetailCardProps) => {
  return (
    <Card
      title={`ImageCapture Account: ${account?.title}`}
      loading={isLoading}
      extra={
        <Space>
          <Link to={`/image-captures/accounts/${account?.id}/edit`}>
            <Button icon={<EditOutlined />} />
          </Link>
          <Popconfirm
            title="Account verwijderen"
            description="Weet je zeker dat je deze account wilt verwijderen?"
            onConfirm={() => deleteMutation?.mutate()}
            okText="Ja"
            cancelText="Nee"
          >
            <Button
              loading={deleteMutation?.isPending}
              danger
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
        </Space>
      }
    >
      <Descriptions
        items={
          [
            { label: "Titel", children: account?.title ?? null },
            { label: "Client ID", children: account?.clientId ?? null },
            { label: "Client Secret", children: account?.clientSecret ?? null },
            { label: "Stage", children: account?.stage ?? null },
          ] satisfies DescriptionsProps["items"]
        }
      />
    </Card>
  );
};
